'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _AvatarGroup = require('@material-ui/lab/AvatarGroup');

var _AvatarGroup2 = _interopRequireDefault(_AvatarGroup);

var _core = require('@ellucian/react-design-system/core');

var _EDSContext = require('../EDSContext/EDSContext');

var _MoreHorizontal = require('@ellucian/ds-icons/lib/MoreHorizontal');

var _MoreHorizontal2 = _interopRequireDefault(_MoreHorizontal);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
    return {
        root: {},
        avatar: {
            backgroundColor: theme.palette.grey['300'],
            fontSize: '1.125rem',
            color: theme.palette.grey['600'],
            border: 'solid ' + _tokens.borderWidthThick + ' ' + theme.palette.grey['100'] + ' !important',
            zIndex: _tokens.zIndexDefault + ' !important'
        },
        popper: {
            marginLeft: '-' + _tokens.spacing40,
            '& :last-child': {
                marginBottom: '0px'
            }
        },
        popWrapper: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginBottom: _tokens.spacing30,
            verticalAlign: 'text-top'
        },
        popAvatar: {
            marginRight: _tokens.spacing20
        },
        smallAvatar: {
            width: '24px',
            height: '24px'
        }
    };
};

var TERTIARY_COLORS_MAP = ['purple', 'iris', 'fountain', 'meadow', 'kiwi', 'saffron', 'tangerine'];
var getColors = function getColors(children) {
    var availableColors = TERTIARY_COLORS_MAP.slice(0);
    var finalColors = [];
    for (var i = 0; i < children.length; i++) {
        if (availableColors.length === 0) {
            availableColors = TERTIARY_COLORS_MAP.slice(0);
        };
        var num = Math.floor(Math.random() * availableColors.length);
        finalColors.push(availableColors[num]);
        availableColors.splice(num, 1);
    };
    return finalColors;
};

var AvatarGroup = _react2.default.forwardRef(function (props) {
    var classes = props.classes,
        children = props.children,
        max = props.max,
        spacing = props.spacing,
        id = props.id,
        rest = _objectWithoutProperties(props, ['classes', 'children', 'max', 'spacing', 'id']);

    var newSpacing = spacing === 'condensed' ? 30 : spacing;

    var GroupRef = _react2.default.createRef();

    var _useState = (0, _react.useState)(),
        _useState2 = _slicedToArray(_useState, 2),
        anchorEl = _useState2[0],
        setAnchorEl = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        open = _useState4[0],
        setOpen = _useState4[1];

    var _useState5 = (0, _react.useState)(getColors(children)),
        _useState6 = _slicedToArray(_useState5, 1),
        colorList = _useState6[0];

    var classOverrides = {
        root: classes.root,
        avatar: classes.avatar
    };

    var colorizedChildren = children.slice(0).map(function (child, i) {
        return _react2.default.cloneElement(child, { color: colorList[i] });
    });

    var groupChildren = colorizedChildren.slice(0, max).map(function (child) {
        if (spacing === 'condensed') {
            //set elements in the condensed avatar group to be non-interactive
            return _react2.default.cloneElement(child, { onClick: function onClick() {}, variant: 'default', component: 'div' });
        } else {
            return _react2.default.cloneElement(child);
        }
    });

    var popperChildren = spacing === 'condensed' ? colorizedChildren.slice(0).map(function (child) {
        return _react2.default.cloneElement(child, { size: 'small' });
    }) : colorizedChildren.slice(max, colorizedChildren.length).map(function (child) {
        return _react2.default.cloneElement(child, { size: 'small' });
    });

    var handleClick = function handleClick(event) {
        var currentTarget = event.currentTarget;

        setAnchorEl(currentTarget);
        setOpen(!open);
    };

    var handleClose = function handleClose() {
        setOpen(false);
    };

    if (colorizedChildren.length > max) {
        groupChildren.push(_react2.default.createElement(
            _core.Avatar,
            { variant: 'interactive', onClick: handleClick },
            spacing === 'condensed' ? _react2.default.createElement(_MoreHorizontal2.default, null) : '+' + popperChildren.length
        ));
    }

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _AvatarGroup2.default,
            Object.assign({}, rest, {
                classes: classOverrides,
                ref: GroupRef,
                max: 50,
                spacing: newSpacing
            }),
            groupChildren
        ),
        _react2.default.createElement(
            _core.Popper,
            {
                role: 'alertdialog',
                open: open,
                anchorEl: anchorEl,
                placement: props.edsContext.dir === 'rtl' ? 'left-start' : 'right-start',
                arrow: true,
                className: classes.popper,
                onClickAway: handleClose,
                disablePortal: true
            },
            popperChildren.map(function (child, i) {
                return _react2.default.createElement(
                    'div',
                    { className: classes.popWrapper, key: id + '_Popper_Avatar_' + i },
                    _react2.default.createElement(
                        'div',
                        { className: classes.popAvatar },
                        child
                    ),
                    child.props.onClick || child.props.href ? _react2.default.createElement(
                        _core.TextLink,
                        { onClick: child.props.onClick, href: child.props.href },
                        child.props.alt ? child.props.alt : child.props.title
                    ) : _react2.default.createElement(
                        _core.Typography,
                        null,
                        child.props.alt ? child.props.alt : child.props.title
                    )
                );
            })
        )
    );
});

AvatarGroup.muiName = 'AvatarGroup';
AvatarGroup.displayName = 'AvatarGroup';

AvatarGroup.propTypes = {
    /**
     * The avatars to stack.
     */
    children: _propTypes2.default.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object,
    /**
     * Max avatars to show before +x.
     * * Value should be greater than or equal to two.
    */
    max: _propTypes2.default.number,
    /**
     * Spacing between avatars.
     * * number:
     *  * Positive number would decrease space between Avatars
     *  * Negative number would increase space between Avatars
     */
    spacing: _propTypes2.default.oneOf(['medium', 'small', 'condensed'], _propTypes2.default.string)
};

AvatarGroup.defaultProps = {
    spacing: 'medium',
    max: 4
};

exports.default = (0, _EDSContext.withEDSContext)((0, _styles2.default)(styles)(AvatarGroup));

// ** INITIAL IMPLEMENTATION: WILL DELETE BEFORE MERGE **
//Grab terminal avatar element after MUI generates it and add popper/ellipsis as necessary
// useEffect(() => {
//     // const handleClick = (event) => {
//     //     console.log('clicking: ' + open);
//     //     const { currentTarget } = event;
//     //     setAnchorEl(currentTarget);
//     //     setOpen(!open);
//     // };
//     // console.log('useeffect: ' + open);
//     if (children.length > max || spacing === 'condensed') {
//         // const newRef = GroupRef.current;
//         // newRef.current.lastChild.addEventListener('click', handleClick);
//         // if (spacing === 'condensed') {
//         //     newRef.lastChild.innerHTML = '<span>...</span>';
//         // };
//         //return () => {newRef.lastChild.removeEventListener('click', handleClick); };
//     }
// }, [ GroupRef, open, children.length, max, spacing]);